import React from "react";

import { Link } from "@Components/ui";

const NavItem = ({ navItemData: { navLink, navName } }) => (
	<Link link={navLink}>{navName}</Link>
);

export default NavItem;
